import clsx from "clsx"
import { Img } from "src/components/unstyled/Img"
import { InfluencerData } from "src/data/product-details/types"
import { toImageCdnUrl } from "src/utilities/images"

const imageSize = 48

const influencers: InfluencerData[] = [
  {
    image:
      "https://ik.imagekit.io/mkgs1djce/api/v1/image/assets%2F93c78d157c5e4c778afa83f29805ff19%2F6b6804c75b84483983ab2f335fb8548f",
    name: "Nadine Müller",
  },
  {
    image:
      "https://ik.imagekit.io/mkgs1djce/api/v1/image/assets%2F93c78d157c5e4c778afa83f29805ff19%2Fdedb55e721874f769af79edc1222aed9",
    name: "Tanja Siemens",
  },
  {
    image:
      "https://ik.imagekit.io/mkgs1djce/api/v1/image/assets%2F93c78d157c5e4c778afa83f29805ff19%2F8d7a281f440847ca95c079b17f4975c3",
    name: "Sophie Kamper",
  },
  {
    image:
      "https://ik.imagekit.io/mkgs1djce/api/v1/image/assets%2F93c78d157c5e4c778afa83f29805ff19%2F2d5b443d76ba47328303384e6917f2c1",
    name: "Madleen Zerbin",
  },
  {
    image:
      "https://ik.imagekit.io/mkgs1djce/api/v1/image/assets%2F93c78d157c5e4c778afa83f29805ff19%2F6d84092b2d994018be1207911615e8ea",
    name: "Olga Repp",
  },
]

function getDailyIndex(length: number): number {
  const date = new Date()
  const midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const dayIndex = Math.floor(midnight.getTime() / (1000 * 60 * 60 * 24))

  return dayIndex % length
}

function getInfluencer() {
  const index = getDailyIndex(influencers.length)

  return influencers[index]
}

export type SocialProofProps = {
  reduced?: boolean
}

export const SocialProof = ({ reduced }: SocialProofProps) => {
  const influencer = getInfluencer()

  if (reduced) {
    return (
      <div className="border-y px-4 py-6">
        <div className={clsx("flex items-center gap-4 text-sm", !influencer && "invisible")}>
          <span>
            Über <strong>57.079 Kunden</strong> vertrauen auf elvent®!
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className="border-y px-4 py-6">
      <div className={clsx("flex items-center gap-4 text-sm", !influencer && "invisible")}>
        <Img
          src={toImageCdnUrl(influencer?.image, { w: imageSize, h: imageSize })}
          alt={influencer?.name}
          width={imageSize}
          height={imageSize}
          className="size-12 shrink-0 rounded-full"
        />
        <span>
          {influencer?.name} und über <strong>57.079 Kunden</strong> vertrauen auf elvent®!
        </span>
      </div>
    </div>
  )
}
